import React, { useState, useEffect } from 'react';
import AOS from 'aos';
import 'aos/dist/aos.css';
import './Works.css';
import featuredImage from '../../images/team-marketing-services.jpg';
import SubHero from '../../components/SubHero/SubHero'
import FeaturedProjects from '../../components/FeaturedProjects/FeaturedProjects';
import heroImage from '../../images/hero1.jpg'
import screenshotImage from '../../images/screenshot.png'
import Tag from '../../components/Tag/Tag';
import twelveclothin from '../../images/works/twelve.png';


const WorksPage = () => {  
  useEffect(() => {
    window.scrollTo(0, 0)
    
    AOS.init({
      duration: 1000,
      once: true,
      easing: 'ease-out',
    });
  }, []);
  

  return (
    <div className="Works">
      <SubHero
        title="Our Portfolio"
        subtitle="Showcasing Our Creative Excellence and Results"
        image={heroImage}
      />


      <div className="BODY">
        <FeaturedProjects showMore={false}/>

        <div className="Works-case-study">
          <div className="Works-container">
            <div className="Works-case-study-content" data-aos="fade-up">
              <div className="Works-case-header">
                <Tag 
                  title="Featured Case Study"
                  variant="primary"
                />

                <h2 className="Works-section-title header-2"> Transforming E-commerce Experience for Twelve Clothin </h2>
              </div>
              <div className="Works-case-grid">
                <div className="Works-case-image-container" data-aos="fade-up">
                  <img src={twelveclothin} alt="Green Life Co. website" className="Works-case-image" />
                </div>
                <div className="Works-case-details" data-aos="fade-up">
                  <div className="Works-case-info">
                    <div className="Works-case-info-item">
                      <span className="Works-case-info-label">Client:</span>
                      <span className="Works-case-info-value"> Twelve Clothin </span>
                    </div>
                    <div className="Works-case-info-item">
                      <span className="Works-case-info-label">Services:</span>
                      <span className="Works-case-info-value"> Web Design, E-commerce, SEO </span>
                    </div>
                    <div className="Works-case-info-item">
                      <span className="Works-case-info-label">Year:</span>
                      <span className="Works-case-info-value">2024</span>
                    </div>
                  </div>
                  <p className="Works-case-text">
                    Twelve Clothin needed a complete e-commerce overhaul to better showcase their sustainable products and simplify the customer journey. We redesigned their entire online presence with a focus on user experience and conversion optimization.
                  </p>
                  <div className="Works-case-results">
                    <div className="Works-case-result">
                      <span className="Works-case-result-number">152%</span>
                      <span className="Works-case-result-label text-1">Increase in Conversions</span>
                    </div>
                    <div className="Works-case-result">
                      <span className="Works-case-result-number">90%</span>
                      <span className="Works-case-result-label text-1">Reduction in Cart Abandonment</span>
                    </div>
                  </div>
                  <a href="https://twelveclothin.ca" target='_blank' className="Works-case-link text-1">
                    View Case Study Sample <span className="Works-link-arrow">→</span>
                  </a>
                </div>
              </div>
            </div>
          </div>
        </div>

        <div className="Works-testimonials">
          <div className="Works-container">
            
            <Tag 
              variant="primary"
              title="Client Feedback"
            />
            
            <div className="Works-testimonials-grid text-1">
              <div className="Works-testimonial" data-aos="fade-up" data-aos-delay="100">
                <div className="Works-testimonial-quote">"Oma Media Space Limited made marketing effortless for us. From content creation to page growth, they knew just what our beauty brand needed."</div>
                <div className="Works-testimonial-author">
                  <div className="Works-testimonial-name">Sapphire Brows and Lashes</div>
                  <div className="Works-testimonial-position">Sapphire Brows and Lashes</div>
                </div>
              </div>
              <div className="Works-testimonial" data-aos="fade-up" data-aos-delay="200">
                <div className="Works-testimonial-quote">""We needed visibility and a solid digital push—Oma Media Space Limited delivered exactly that. "</div>
                <div className="Works-testimonial-author">
                  <div className="Works-testimonial-name"> GND Logistics </div>
                  <div className="Works-testimonial-position"> GND Logistics </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>

    </div>
  );
};

export default WorksPage;